<template>
  <q-popup-edit
    ref="popupEdit"
    class="cmp-domain-popup"
    content-class="domain-popup"
    anchor="top middle"
    self="bottom middle"
    v-bind="$attrs"
    :cover="false"
    v-on="$listeners"
  >
    <slot></slot>
  </q-popup-edit>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { QPopupEdit } from 'quasar';

@Component({
  components: {
    QPopupEdit,
  },
})
export default class DomainPopup extends Vue {
  hide() {
    (this.$refs.popupEdit as any).hide();
  }
}
</script>

<style lang="scss">
// don't use SCOPED styles because quasar tooltip is appended
// to other location in the code and it won't work.
.wsk-root .domain-popup.q-popup-edit {
  pointer-events: initial !important;
  background: $domain-popup-bg;
  color: $domain-popup-color;

  border: 1px solid $domain-popup-border;
  border-radius: 6px;
  box-shadow: 0 10px 44px -10px rgba(8, 11, 13, 0.15);
  padding: 0;
  overflow: visible !important; // TODO remove temp fix
  z-index: 100;
  max-width: 394px !important; // TODO remove temp fix

  &:after {
    // triangle bottom arrow
    content: '';
    position: absolute;
    display: block;
    top: calc(100% - 2px);
    left: 0;
    right: 0;
    margin: auto;

    width: 0;
    height: 0;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-top: 12px solid $domain-popup-triangle;
  }

  p {
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0;
    line-height: 20px;
    color: $domain-popup-color;
  }

  .q-btn.text-ws-base100 {
    .q-btn__content {
      span,
      svg {
        color: $ws-base100;
        transition: color $element-hover-animation-speed
          $element-hover-animation-type;
      }

      svg {
        margin-right: map-get($space-sm, x);

        &[title='support'] {
          position: relative;
          //top: -1px; // correction - visually centered on Y axis
        }
      }
    }
    &:hover .q-btn__content {
      span,
      svg {
        color: $ws-black;
      }
    }
  }
}
</style>
